{
  "backButton": "Grįžti į {prevMenuButton}",
  "moreActions": "Daugiau veiksmų",
  "unavailable": "Nepasiekiama, norėdami gauti daugiau informacijos, išskleiskite"
}
